// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"999be714","455":"2f5c4e43","977":"b3afcc04"}[chunkId] + ".chunk.js";
};